module.exports = __webpack_public_path__ + "img/duncan-kidd-uwFjCwhXMhE-compress.37e91784.jpg";